export const environment = {
  name: 'test',
  elmah: {
    key: '7eeb8e0eb1904ad595b093a3b1af241c',
    id: '368a4786-42dc-4a93-bdfc-a2562d89c136'
  }
};
